<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="show"
      max-width="600"
      @input="v => v || _closeDialog()"
    >
      <v-card>
        <v-card-title class="card-title">
          <span class="headline white--text text-uppercase">Create Payout</span>
        </v-card-title>
        <v-layout class="saldo-info">
          <v-flex>
            <user-info
              label="Saldo"
              :value="saldo | currency('€')"
              readonly
            />
          </v-flex>
          <v-flex>
            <user-info
              label="Open Payouts"
              :value="openPayouts | currency('€')"
              readonly
            />
          </v-flex>
          <v-flex>
            <user-info
              label="Available"
              :value="availableAmount | currency('€')"
              readonly
            />
          </v-flex>
        </v-layout>
        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container fluid>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm6
                >
                  Amount:
                  <v-text-field
                    v-model="amount"
                    type="number"
                    label="Amount"
                    single-line
                    box
                    required
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>

          <v-alert
            v-if="createPayoutError"
            :value="true"
            type="error"
            class="my-3"
          >
            {{ createPayoutError }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="blue darken-1"
            flat="flat"
            :disabled="processing"
            @click="cancelAction()"
          >
            cancel
          </v-btn>

          <v-btn
            color="blue darken-1"
            flat="flat"
            :disabled="processing"
            @click="_createPayout()"
          >
            create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import UserInfo from '../users/backend/UserInfo';

export default {
  name: 'CreatePayout',
  comments: {
    'user-info': UserInfo,
  },
  components: { UserInfo },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: Number,
      required: true,
    },
    saldo: {
      type: Number,
      default: 0.00,
    },
    openPayouts: {
      type: Number,
      default: 0.00,
    },
    createPayoutError: {
      type: String,
      default: '',
    },
    processing: {
      type: Boolean,
      default: false,
    },
    submitAction: {
      type: Function,
      default: () => ({}),
    },
    cancelAction: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    return {
      valid: true,
      show: this.dialog,
      availableAmount: this.saldo - this.openPayouts,
      amount: this.saldo - this.openPayouts,
    };
  },
  watch: {
    dialog(val) {
      this.show = val;
    },
    data(val) {
      this.amount = val.amount;
    },
  },
  methods: {
    _createPayout() {
      if (this.$refs.form.validate()) {
        this.submitAction({
          userId: this.userId,
          amount: this.amount,
        });
      }
    },
    _closeDialog() {
      this.cancelAction();
    },
  },
};
</script>

<style lang="scss" scoped>
  .saldo-info {
    width: 90%;
    margin: 5px auto auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/baader/CreatePayout.vue